var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('wc-cookie-law',{ref:"wcCookieLaw",attrs:{"skip-routes":['privacy', 'machines-analytics-report'],"skip-routes-namespace":['manager']}}),_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }